module.exports = __webpack_public_path__ + "media/images/footer-addr-icon-b5d65406f05436bf1946efa553a763c9.png";